import React from "react";
import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const Level = ({ svgProps, pathProps }: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };

  return (
    <svg {...mergedSvgProps}>
      <path
        d="M20.39 8.56001L19.15 10.42C19.7432 11.6031 20.0336 12.9148 19.9952 14.2377C19.9568 15.5606 19.5908 16.8533 18.93 18H5.07C4.21117 16.5101 3.8553 14.7831 4.05514 13.0751C4.25499 11.367 4.99991 9.76884 6.17948 8.51744C7.35905 7.26604 8.91047 6.42805 10.6037 6.12771C12.297 5.82736 14.042 6.08064 15.58 6.85001L17.44 5.61001C15.4695 4.33293 13.1125 3.78997 10.7819 4.07628C8.45133 4.36259 6.29581 5.45991 4.69306 7.17595C3.0903 8.892 2.14253 11.1173 2.01582 13.462C1.8891 15.8067 2.59152 18.1212 4 20H20C21.2266 18.3613 21.9207 16.3856 21.9887 14.3398C22.0566 12.2939 21.4951 10.2765 20.38 8.56001H20.39Z"
        {...mergedPathProps}
      />
      <path
        d="M10.59 15.41C10.7758 15.596 10.9963 15.7435 11.2391 15.8441C11.4819 15.9448 11.7422 15.9966 12.005 15.9966C12.2678 15.9966 12.5281 15.9448 12.7709 15.8441C13.0137 15.7435 13.2343 15.596 13.42 15.41L19.08 6.92001L10.59 12.58C10.4041 12.7658 10.2565 12.9863 10.1559 13.2291C10.0552 13.4719 10.0034 13.7322 10.0034 13.995C10.0034 14.2578 10.0552 14.5181 10.1559 14.7609C10.2565 15.0037 10.4041 15.2243 10.59 15.41V15.41Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default Level;
